import axios from '../../common/utils/interceptor';
import { ValidateAssessmentLaunchConfig } from '../../assessment/interfaces';
import { WorkflowItemAssessmentCodes, SessionStore, WorkflowItemCode, routeMappings, apiUrls } from '../../constants';
import { TaskItemStatus } from '../constants';
import { Task, TaskItem } from '../interfaces';
import { getAssessmentUrlApp } from './getAssessmentUrlApp';
import updateTaskItem from './updateTaskItem';
import firstlaunchConfigOfCompletedItemOfAnyTask from './firstlaunchConfigOfCompletedItemOfAnyTask';
import { fetchAssessmentDetail } from './fetchAssessmentDetail';
import { User, WorkflowItem } from '../../store/interfaces';
import { Location, NavigateFunction } from 'react-router-dom';

export const initializeTask = async (
  task: Task,
  userSessionActive: boolean,
  navigate: NavigateFunction,
  location: Location,
  candidate: User,
  launchAssessmentConfig?: ValidateAssessmentLaunchConfig | null,
  item?: TaskItem,
  currentWorkflowItem?: WorkflowItem,
): Promise<void> => {
  sessionStorage.removeItem(SessionStore.allowRedirectToTasklist);
  let currentItem: TaskItem;
  // initialize currentItem with item ( if passed as parameter)
  if (item) {
    currentItem = item;
  } else {
    const firstNotStartedOrInProgressItem = task.items.find(
      (item) =>
        item.status === TaskItemStatus.IN_PROGRESS || !item.status || item.status === TaskItemStatus.NOT_STARTED,
    );
    currentItem = firstNotStartedOrInProgressItem ? firstNotStartedOrInProgressItem : task.items[0];
  }
  // SHL App mobile app option

  if (WorkflowItemAssessmentCodes.includes(currentItem.code)) {
    // set session storage for launchconfig
    const currentItemStateData = currentItem.state && {
      ...JSON.parse(currentItem.state),
      taskId: task.id,
      itemId: currentItem.id,
    };
    let tempLaunchConfig = currentItemStateData || launchAssessmentConfig;

    // Linearflow
    if (!tempLaunchConfig && currentWorkflowItem) {
      const assessmentDetails = await fetchAssessmentDetail(currentItem);
      const launchconfig = firstlaunchConfigOfCompletedItemOfAnyTask(
        task,
        currentItem,
        assessmentDetails,
        currentWorkflowItem,
      );
      if (launchconfig) tempLaunchConfig = JSON.parse(launchconfig);
      else return;
    }

    // if Quiz is completed --> redirect to Quiz feedback page
    if (currentItem.code === WorkflowItemCode.EXPQUIZ && currentItem.status === TaskItemStatus.COMPLETED) {
      navigate(
        `${routeMappings['TASK']}/${tempLaunchConfig.taskId}${routeMappings[currentItem.code]}/${currentItem.id}${
          routeMappings['QUIZ_FEEDBACK']
        }`,
      );
      return;
    }
    sessionStorage.setItem(SessionStore.launchconfig, JSON.stringify(tempLaunchConfig));
    // if session is active --> redirect to launch assessment
    if (userSessionActive || currentItem.code === WorkflowItemCode.EXPQUIZ) {
      // Update sessionStorage with fetched item and mark it IN_PROGRESS
      updateTaskItem(
        { ...currentItem, taskId: task.id, state: JSON.stringify(tempLaunchConfig) },
        TaskItemStatus.IN_PROGRESS,
      );
      sessionStorage.setItem(SessionStore.isTaskInitialized, 'true');
      if (tempLaunchConfig && (await getAssessmentUrlApp(tempLaunchConfig, candidate))) return;

      navigate(
        `${routeMappings['TASK']}/${tempLaunchConfig.taskId}${routeMappings[currentItem.code]}/${
          tempLaunchConfig.itemId
        }`,
      );
    } else {
      // if not --> send it to login
      updateTaskItem({ ...currentItem, taskId: task.id, state: JSON.stringify(tempLaunchConfig) });
      navigate(`${routeMappings['LOGIN']}`);
    }
  } else {
    try {
      if (currentItem.status !== TaskItemStatus.COMPLETED) {
        const request = {
          wfItemId: currentItem.id,
          wfItemState: '',
        };
        const { data } = await axios.post(apiUrls.INITIALIZE_TASK, request);

        // Update sessionStorage with fetched item and mark it IN_PROGRESS
        updateTaskItem({ taskId: task.id, ...data }, TaskItemStatus.IN_PROGRESS);
      }
      navigate(`${routeMappings['TASK']}/${task.id}${routeMappings[currentItem.code]}/${currentItem.id}`, {
        state:
          currentItem.code === WorkflowItemCode.EXPVIDEOTASK
            ? { background: location, taskTitle: task.title, status: currentItem.status }
            : undefined,
      });
      sessionStorage.setItem(SessionStore.isTaskInitialized, 'true');
    } catch (e) {
      // TODO: Show error in proceeding further
      console.error('Task initialize error: ', e);
    }
  }
};
